import { Button } from '@/platform/ui';
import { PlusIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';
import Line from './Line';

const Lines = ({ data, onChange }) => {
    const { auth, categories } = usePage().props;

    const addLine = () => {
        onChange('lines', [
            ...(data?.lines || []),
            {
                id: `new-${Date.now()}`,
                type: 'fee',
                category: categories?.[0] ?? '',
                description: '',
                amount: 0,
                customer_amount: 0,
                extra: 0,
            },
        ]);
    };

    const handleChange = (id, field, value) => {
        onChange(
            'lines',
            data?.lines?.map(line => {
                if (line.id == id) {
                    const newLine = { ...line };

                    if (
                        field === 'type' &&
                        value === 'payroll' &&
                        newLine?.amount == 0
                    ) {
                        newLine.amount = auth?.customer?.payroll_fee || 0;
                    }

                    return {
                        ...newLine,
                        [field]: value,
                    };
                }

                return line;
            })
        );
    };

    const handleDelete = id => {
        onChange(
            'lines',
            data?.lines?.filter(line => line?.id !== id)
        );
    };

    return (
        <>
            <div className='my-4 flex justify-end'>
                <Button type='button' onClick={addLine}>
                    <PlusIcon className='size-5' />
                    Regel toevoegen
                </Button>
            </div>

            {data?.lines?.map(line => (
                <Line
                    key={line.id}
                    line={line}
                    onChange={handleChange}
                    onDelete={handleDelete}
                />
            ))}
        </>
    );
};

export default Lines;
